/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { BaseCardHeader } from './base-card-header';
import { parseStreamUrl } from '../file-type-utils';
import { VideoStream } from '../../../../video-stream';
import { useGlobalSourceManagementStore } from '@/stores/globalSourceManagementStore';

interface VideoCardHeaderProps {
  title: string;
  backgroundColor?: string;
  relevanceValue: number;
  groupedCards?: any[];
  currentCardIndex: number;
  streamLinkWithTimestamp: string;
  onClose: () => void;
}

export const VideoCardHeader: React.FC<VideoCardHeaderProps> = ({
  streamLinkWithTimestamp,
  ...baseProps
}) => {
  const videoId = parseStreamUrl(streamLinkWithTimestamp).videoId;
  const globalSourceManager = useGlobalSourceManagementStore();
  const [videoLoading, setVideoLoading] = useState<boolean>(false);
  const [videoWithError, setVideoWithError] = useState<boolean>(false);

  const renderVideoContent = () => {
    if (videoId) {
      return (
        <div className='h-full w-full overflow-hidden flex items-center justify-center bg-black relative'>
          {videoLoading && (
            <div className="absolute inset-0 z-40 flex items-center justify-center bg-black/50">
              <div className="flex flex-col items-center gap-3">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/30 border-t-white"></div>
                <span className="text-sm text-white font-medium">Loading video...</span>
              </div>
            </div>
          )}
          {videoWithError && (
            <div className="absolute inset-0 z-40 flex items-center justify-center bg-black/50">
              <div className="flex flex-col items-center gap-3 text-center">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-500/20">
                  <svg
                    className="h-6 w-6 text-red-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium">Falha ao carregar vídeo</p>
                  <p className="text-sm text-white/70 mt-1">Tente novamente mais tarde</p>
                </div>
              </div>
            </div>
          )}
          <VideoStream 
            controls
            videoId={videoId}
            currentTime={globalSourceManager.videoTime || 0}
            responsive
            onVideoLoading={setVideoLoading}
            onVideoError={setVideoWithError}
          />
        </div>
      );
    }

    return (
      <div className="absolute inset-0 z-40 flex items-center justify-center bg-black/50">
        <div className="flex flex-col items-center gap-3 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-500/20">
            <svg
              className="h-6 w-6 text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <div>
            <p className="text-white font-medium">Falha ao carregar vídeo</p>
            <p className="text-sm text-white/70 mt-1">Tente novamente mais tarde</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <BaseCardHeader
      {...baseProps}
      showGradient={false}
      isVideo={true}
    >
      {renderVideoContent()}
    </BaseCardHeader>
  );
};